import React from 'react';
import './EbookHero.css';
import UseScrollToId from '../../navigation/scrolltopage/UseScrollToId';

const EbookHero = () => {

 // Panggil hook untuk mendapatkan fungsi scroll
  const scrollTo = UseScrollToId();
  const handleCtaClick = (event) => {
    event.preventDefault(); // Mencegah navigasi default tag <a>
    scrollTo('id-ebook-collection'); // Panggil fungsi scroll dengan ID target
  };

  const handleBuyClick = () => {
    // Menggunakan props 'myLink' secara langsung
    window.open('https://lynk.id/rekanata.contractors', '_blank');
  };

  return (
    <div className="ebook-hero-container">
      <div className="ebook-hero-content">
        <h1 className="ebook-hero-title">Buka Potensi Penuh Anda - Panduan Lengkap Ebook</h1>
        <h2 className="ebook-hero-subtitle">Ebook ini adalah peta jalan Anda menuju penguasaan materi. Pelajari teknik belajar efektif, strategi teruji, dan raih kesuksesan akademik atau profesional yang Anda impikan.</h2>
        <a className="ebook-hero-cta-button" onClick={handleBuyClick}>
          Lihat Koleksi Ebook!
        </a>
      </div>
    </div>
  );
};

export default EbookHero;